import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/catch";
import { AdalHttp } from "../../services/adal.http.service";

@Injectable()
export class ModelTypeRegistrationService {
    
    constructor(private http: AdalHttp) {
    }

    addModelType(modelType: string, description: string): Observable<any> {

        var requestBody = {
            'ModelTypeId': modelType,
            'description': description
        };
        let productUrl =  "/api/modeltype";
        return this.http.post(productUrl, requestBody)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    
}


/** WEBPACK FOOTER **
 ** ./app/main/modelTypeRegistration/model-type-registration.service.ts
 **/